import { useWallet } from "@txnlab/use-wallet";
import { Button, ButtonProps } from "./ui/button";
import { Plug } from "lucide-react";
import AccountSheetContext from "@/providers/account-sheet";
import { MouseEventHandler, useContext } from "react";

const defaultConnectLabel = "Connect your Wallet";

export function ConnectButton({
  className,
  disabled,
  onClick,
  onDisconnectedClick,
  children,
  connectLabel = defaultConnectLabel,
}: ButtonProps & {
  connectLabel?: string;
  onDisconnectedClick?: MouseEventHandler<HTMLButtonElement>;
}) {
  const { activeAccount } = useWallet();
  const { setOpen: setAccountSheetOpen } = useContext(AccountSheetContext);
  return (
    <Button
      className={className}
      disabled={activeAccount ? disabled : false}
      onClick={
        activeAccount
          ? onClick
          : (e: any) => {
              if (onDisconnectedClick) {
                onDisconnectedClick(e);
              }
              setAccountSheetOpen(true);
            }
      }
    >
      {activeAccount ? (
        children
      ) : (
        <>
          <Plug size={18} className="mr-1.5" />
          {connectLabel}
        </>
      )}
    </Button>
  );
}
